/* ==========================================================================
   FlatWine — search.js
   Búsqueda predictiva del encabezado. El formulario GET sigue funcionando
   sin este archivo. Aquí sólo se añaden sugerencias, teclado y el panel
   compacto de móvil.
   ========================================================================== */

(function () {
  'use strict';

  var DEBOUNCE_MS = 200;
  var MIN_CHARS = 2;
  /* Si a11y.js no cargó, la trampa no puede quedar en nada: sin ella el foco
     se escapa a la página de detrás del velo. Se avisa y se sigue sin ciclo,
     que es peor pero no invisible. */
  var avisadoSinTrampa = false;
  function atrapar(root, event) {
    if (window.fwFocusTrap) return window.fwFocusTrap.atrapar(root, event);
    /* El filtro por Tab va ANTES del aviso, y el aviso solo sale una vez. Sin
       las dos cosas, escribir en un campo con el panel abierto emitía un error
       por carácter y enterraba el único mensaje que explica el problema. */
    if (event.key !== 'Tab' || avisadoSinTrampa) return false;
    avisadoSinTrampa = true;
    console.error('[a11y] fwFocusTrap no está disponible: el panel no atrapa el foco');
    return false;
  }
  var COMPACT = '(max-width: 899px)';

  function debounce(fn, wait) {
    var timer;
    return function () {
      var ctx = this;
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function empty(node) {
    while (node.firstChild) node.removeChild(node.firstChild);
  }

  function text(node, value) {
    node.textContent = value == null ? '' : String(value);
  }

  function attr(el, name) {
    return el.getAttribute(name) || '';
  }

  function safeUrl(value) {
    if (!value || typeof value !== 'string') return '';
    try {
      var parsed = new URL(value, window.location.origin);
      if (parsed.protocol === 'http:' || parsed.protocol === 'https:') return parsed.href;
    } catch (err) {
      return '';
    }
    return '';
  }

  function resourceImage(resource) {
    if (!resource) return '';
    if (resource.featured_image && resource.featured_image.url) return safeUrl(resource.featured_image.url);
    if (typeof resource.image === 'string') return safeUrl(resource.image);
    if (resource.image && resource.image.url) return safeUrl(resource.image.url);
    return '';
  }

  var avisoMoneda = false;
  function formatPrice(price, moneyFormat) {
    var amount = Number(price);
    if (!isFinite(amount)) return '';
    if (typeof window.fwMoney !== 'function') {
      /* Sin format.js el precio desaparecía de las sugerencias sin decir nada,
         y product.js resolvía la misma ausencia de otra forma. Al menos que
         quede constancia. */
      if (!avisoMoneda) {
        avisoMoneda = true;
        console.error('[search] format.js no cargó; las sugerencias van sin precio');
      }
      return '';
    }
    return window.fwMoney(amount * 100, moneyFormat);
  }

  function initPredictive(root) {
    var form = root.querySelector('[data-predictive-form]');
    var input = root.querySelector('[data-predictive-input]');
    var results = root.querySelector('[data-predictive-results]');
    var status = root.querySelector('[data-predictive-status]');
    var endpoint = attr(root, 'data-predictive-url');
    /* Sin esto la búsqueda predictiva se apagaba en silencio: el campo seguía
       ahí y no sugería nada, sin que nadie pudiera saber por qué. Se dice cuál
       de las cuatro piezas falta, que es lo que hace falta para arreglarlo. */
    if (!form || !input || !results || !endpoint) {
      var faltan = [];
      if (!form) faltan.push('[data-predictive-form]');
      if (!input) faltan.push('[data-predictive-input]');
      if (!results) faltan.push('[data-predictive-results]');
      if (!endpoint) faltan.push('data-predictive-url');
      console.error('[search] sugerencias desactivadas, falta: ' + faltan.join(', '));
      return;
    }

    var moneyFormat = attr(root, 'data-money-format');
    var strings = {
      loading: attr(root, 'data-i18n-loading'),
      results: attr(root, 'data-i18n-results'),
      empty: attr(root, 'data-i18n-empty'),
      error: attr(root, 'data-i18n-error'),
      products: attr(root, 'data-i18n-products'),
      collections: attr(root, 'data-i18n-collections'),
      pages: attr(root, 'data-i18n-pages'),
      viewAll: attr(root, 'data-i18n-view-all'),
      unavailable: attr(root, 'data-i18n-unavailable')
    };

    var controller = null;
    var activeIndex = -1;
    var options = [];
    var open = false;

    function setStatus(message) {
      if (status) text(status, message);
    }

    function clearActive() {
      activeIndex = -1;
      options = [];
      input.removeAttribute('aria-activedescendant');
    }

    function setBusy(busy) {
      if (busy) {
        input.setAttribute('aria-busy', 'true');
      } else {
        input.removeAttribute('aria-busy');
      }
    }

    function closeList() {
      open = false;
      results.hidden = true;
      empty(results);
      results.classList.remove('is-loading');
      input.setAttribute('aria-expanded', 'false');
      clearActive();
      setBusy(false);
    }

    function setActive(index) {
      if (!options.length) return;
      if (index < 0) index = options.length - 1;
      if (index >= options.length) index = 0;
      activeIndex = index;
      options.forEach(function (option, i) {
        var selected = i === activeIndex;
        option.setAttribute('aria-selected', selected ? 'true' : 'false');
        if (selected) {
          input.setAttribute('aria-activedescendant', option.id);
          if (typeof option.scrollIntoView === 'function') {
            option.scrollIntoView({ block: 'nearest' });
          }
        }
      });
    }

    function resultsPageUrl() {
      var action = form.getAttribute('action') || form.action || '';
      var href = '';
      try {
        var url = new URL(action, window.location.origin);
        var qField = form.querySelector('[name="q"]');
        var typeField = form.querySelector('[name="type"]');
        url.searchParams.set('q', qField ? qField.value : '');
        if (typeField && typeField.value) url.searchParams.set('type', typeField.value);
        href = url.href;
      } catch (err) {
        return '';
      }
      return safeUrl(href);
    }

    function addViewAllOption() {
      var href = resultsPageUrl();
      if (!href) return;
      var option = document.createElement('a');
      option.className = 'predictive__view-all';
      option.id = input.id + '-opt-all';
      option.setAttribute('role', 'option');
      option.setAttribute('aria-selected', 'false');
      option.href = href;
      text(option, strings.viewAll);
      results.appendChild(option);
    }

    function refreshOptions() {
      options = Array.prototype.slice.call(results.querySelectorAll('[role="option"]'));
    }

    function optionNode(resource, type, index) {
      var href = safeUrl(resource.url);
      /* Descartar el resultado es lo correcto —una URL que no es http(s) no se
         pone en un enlace—, pero desaparecía sin constancia: alguien podría
         pasar semanas sin entender por qué un producto nunca sale sugerido. */
      if (!href) {
        console.warn('[search] resultado descartado por URL no válida:', resource.url, resource.title || '');
        return null;
      }

      var option = document.createElement('a');
      option.className = 'predictive__option';
      option.id = input.id + '-opt-' + type + '-' + index;
      option.setAttribute('role', 'option');
      option.setAttribute('aria-selected', 'false');
      option.href = href;

      var imageUrl = resourceImage(resource);
      if (imageUrl) {
        var img = document.createElement('img');
        img.className = 'predictive__thumb';
        img.src = imageUrl;
        img.alt = '';
        img.width = 48;
        img.height = 48;
        img.loading = 'lazy';
        option.appendChild(img);
      }

      var body = document.createElement('span');
      body.className = 'predictive__body';

      var title = document.createElement('span');
      title.className = 'predictive__title';
      text(title, resource.title || '');
      body.appendChild(title);

      if (type === 'product') {
        var meta = document.createElement('span');
        meta.className = 'predictive__meta';
        if (resource.available === false) {
          text(meta, strings.unavailable);
        } else {
          text(meta, formatPrice(resource.price, moneyFormat));
        }
        if (meta.textContent) body.appendChild(meta);
      }

      option.appendChild(body);
      return option;
    }

    function appendGroup(label, list, type) {
      if (!list || !list.length) return 0;

      var group = document.createElement('div');
      group.className = 'predictive__group-block';
      group.setAttribute('role', 'group');
      group.setAttribute('aria-label', label);

      var heading = document.createElement('p');
      heading.className = 'predictive__group label';
      heading.setAttribute('aria-hidden', 'true');
      heading.setAttribute('role', 'presentation');
      text(heading, label);
      group.appendChild(heading);

      var count = 0;
      list.forEach(function (resource, index) {
        var option = optionNode(resource, type, index);
        if (!option) return;
        group.appendChild(option);
        count += 1;
      });
      if (!count) return 0;
      results.appendChild(group);
      return count;
    }

    function showMessage(message) {
      empty(results);
      clearActive();
      setBusy(false);
      results.classList.remove('is-loading');
      var note = document.createElement('p');
      note.className = 'predictive__empty';
      note.setAttribute('role', 'presentation');
      note.setAttribute('aria-hidden', 'true');
      text(note, message);
      results.appendChild(note);
      addViewAllOption();
      refreshOptions();
      results.hidden = false;
      open = true;
      input.setAttribute('aria-expanded', 'true');
      setStatus(message);
    }

    function render(payload) {
      empty(results);
      clearActive();
      setBusy(false);
      results.classList.remove('is-loading');

      var bucket = payload && payload.resources && payload.resources.results
        ? payload.resources.results
        : {};
      var total = 0;
      total += appendGroup(strings.products, bucket.products, 'product');
      total += appendGroup(strings.collections, bucket.collections, 'collection');
      total += appendGroup(strings.pages, bucket.pages, 'page');

      if (!total) {
        showMessage(strings.empty);
        return;
      }

      addViewAllOption();
      refreshOptions();
      results.hidden = false;
      open = true;
      input.setAttribute('aria-expanded', 'true');
      setStatus(strings.results + ' ' + String(total));
    }

    function buildUrl(query) {
      var base = new URL(endpoint, window.location.origin);
      base.search = '';
      return base.href
        + (base.href.indexOf('?') === -1 ? '?' : '&')
        + 'q=' + encodeURIComponent(query)
        + '&resources[type]=product,collection,page'
        + '&resources[limit]=4'
        + '&resources[options][unavailable_products]=last';
    }

    function suggest(query) {
      if (controller) controller.abort();
      controller = new AbortController();
      results.classList.add('is-loading');
      setBusy(true);
      setStatus(strings.loading);

      fetch(buildUrl(query), {
        signal: controller.signal,
        headers: { Accept: 'application/json' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('suggest-failed');
          return response.json();
        })
        .then(function (payload) {
          render(payload);
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          /* Al comprador se le avisa bien. Lo que faltaba era el diagnóstico:
             un endpoint caído, un 429 por límite de peticiones y un JSON
             malformado se veían todos iguales desde fuera. Era el único catch
             de red del tema sin registro. */
          console.error('[search] falló la búsqueda predictiva', error);
          showMessage(strings.error);
        });
    }

    var onInput = debounce(function () {
      var query = input.value.replace(/^\s+|\s+$/g, '');
      if (query.length < MIN_CHARS) {
        if (controller) controller.abort();
        closeList();
        setStatus('');
        return;
      }
      suggest(query);
    }, DEBOUNCE_MS);

    input.addEventListener('input', onInput);

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        if (!open) return;
        event.preventDefault();
        event.stopPropagation();
        closeList();
        setStatus('');
        input.focus();
        return;
      }

      if (!open) return;

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        setActive(activeIndex + 1);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        setActive(activeIndex - 1);
      } else if (event.key === 'Enter' && activeIndex >= 0 && options[activeIndex]) {
        event.preventDefault();
        options[activeIndex].click();
      }
    });

    document.addEventListener('click', function (event) {
      if (!open) return;
      if (!root.contains(event.target)) closeList();
    });
  }

  function initHeaderPanel(root) {
    var toggle = root.querySelector('[data-search-open]');
    var panel = root.querySelector('[data-search-panel]');
    var closer = root.querySelector('[data-search-close]');
    var input = root.querySelector('[data-predictive-input]');
    /* En móvil este botón es la única forma de llegar al buscador. Si falta el
       panel, el botón queda muerto para siempre y antes no se decía nada. */
    if (!toggle || !panel) {
      if (toggle && !panel) console.error('[search] hay botón de buscar pero no está [data-search-panel]: el buscador móvil queda muerto');
      return;
    }

    var lastFocused = null;
    var mq = window.matchMedia(COMPACT);

    function isCompact() {
      return mq.matches;
    }

    function trap(event) {
      if (!panel.classList.contains('is-open') || !isCompact()) return;
      atrapar(panel, event);
    }

    var dialogLabel = attr(panel, 'data-dialog-label') || attr(toggle, 'aria-label') || '';
    if (!dialogLabel) {
      var toggleName = toggle.querySelector('.visually-hidden');
      if (toggleName) dialogLabel = toggleName.textContent.replace(/^\s+|\s+$/g, '');
    }

    function setDialogMode(on) {
      if (on) {
        panel.setAttribute('role', 'dialog');
        panel.setAttribute('aria-modal', 'true');
        if (dialogLabel) panel.setAttribute('aria-label', dialogLabel);
      } else {
        panel.removeAttribute('role');
        panel.removeAttribute('aria-modal');
        panel.removeAttribute('aria-label');
      }
    }

    function openPanel() {
      if (!isCompact()) return;
      lastFocused = document.activeElement;
      panel.classList.add('is-open');
      panel.inert = false;
      setDialogMode(true);
      document.body.classList.add('has-overlay');
      toggle.setAttribute('aria-expanded', 'true');
      if (input) input.focus();
    }

    function closePanel(options) {
      options = options || {};
      var wasOpen = panel.classList.contains('is-open');
      panel.classList.remove('is-open');
      setDialogMode(false);
      panel.inert = isCompact();
      document.body.classList.remove('has-overlay');
      toggle.setAttribute('aria-expanded', 'false');
      if (wasOpen && options.restoreFocus !== false) {
        if (lastFocused && lastFocused.isConnected && typeof lastFocused.focus === 'function') lastFocused.focus();
        else toggle.focus();
      }
    }

    toggle.setAttribute('aria-expanded', 'false');
    panel.inert = isCompact();
    toggle.addEventListener('click', function () {
      if (panel.classList.contains('is-open')) closePanel();
      else openPanel();
    });

    if (closer) closer.addEventListener('click', closePanel);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && panel.classList.contains('is-open')) {
        var listbox = panel.querySelector('[data-predictive-results]');
        var campo = panel.querySelector('[data-predictive-input]');
        /* Se cedía el turno al manejador del input siempre que hubiera
           sugerencias abiertas, pero ese manejador solo corre si el input
           TIENE el foco. Con el foco en una sugerencia o en el botón de
           cerrar, Escape no hacía absolutamente nada, y el panel es
           position:fixed a pantalla completa con el body bloqueado: la única
           salida era encontrar la ✕. Ahora solo se cede el turno si el foco
           está de verdad donde ese manejador puede actuar. */
        if (listbox && !listbox.hidden && campo && document.activeElement === campo) return;
        event.preventDefault();
        closePanel();
        return;
      }
      trap(event);
    });

    document.addEventListener('click', function (event) {
      if (!panel.classList.contains('is-open') || !isCompact()) return;
      if (root.contains(event.target)) return;
      closePanel();
    });

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', function () {
        if (!isCompact()) closePanel({ restoreFocus: false });
        else if (!panel.classList.contains('is-open')) panel.inert = true;
      });
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(function () {
        if (!isCompact()) closePanel({ restoreFocus: false });
        else if (!panel.classList.contains('is-open')) panel.inert = true;
      });
    }
  }

  /* Mismo caso que menu.js: estos elementos viven en la sección del
     encabezado, que el editor re-renderiza. Sin esto la búsqueda predictiva y
     el panel compacto quedaban muertos en cuanto el cliente tocaba un ajuste. */
  var yaIniciados = new WeakSet();

  function unaVez(fn) {
    return function (el) {
      if (yaIniciados.has(el)) return;
      yaIniciados.add(el);
      fn(el);
    };
  }

  function boot() {
    document.querySelectorAll('[data-predictive-search]').forEach(unaVez(initPredictive));
    document.querySelectorAll('[data-header-search]').forEach(unaVez(initHeaderPanel));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
